module.exports = __webpack_public_path__ + "static/media/github.9dba69b0.png";